export const INTERNAL_DATETIME_FORMAT = 'yyyy-MM-dd HH:MM'
export const INTERNAL_DATE_FORMAT = 'yyyy-MM-dd'
export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy'
export const WELLS_DEFAULT_SEARCH_RESULTS_SIZE = 20
export enum ActivityType {
  CONSENTED = 'Consented',
  PERMITTED = 'Permitted',
  LEGACY = 'Legacy',
}

export enum WellStatus {
  DECOMMISSIONED = 'Decommissioned',
  EXISTING = 'Existing',
  NOT_DRILLED = 'Not Drilled',
  PROPOSED = 'Proposed',
}

export enum WellType {
  GEOTHERMAL = 'Geothermal Well',
}

export enum ScreenType {
  UNKNOWN = '(unknown)',
  DRILLED_PVC = 'Drilled PVC',
  DRILLED_CASING = 'Drilled casing',
  HDPE_PLASTIC = 'HDPE Plastic',
  NO_SCREEN = 'No Screen',
  OPEN_HOLE = 'Open hole',
  PERFORATED_CASING = 'Perforated casing',
  POROUS_CONCRETE_LINER = 'Porous concrete liner',
  SLOTTED_CASING = 'Slotted Casing',
  SLOTTED_PVC = 'Slotted PVC',
  SLOTTED_STAINLESS_STEEL = 'Slotted stainless steel',
  SLOTTED_STEEL = 'Slotted steel',
}

export enum WellRecordStatus {
  DRAFT = 'Draft',
  PUBLISHED = 'Published',
  UNDER_REVIEW = 'Under review',
}

enum MimeTypes {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  PDF = 'application/pdf',
  CSV = 'text/csv',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
  AGS = '.ags',
  AGS_UPPER = '.AGS',
  AQT = '.aqt',
  AQT_UPPER = '.AQT',
}

export const WELLS_DEFAULT_MIME_TYPES = Object.values(MimeTypes)

enum ExtensionTypes {
  PDF = 'pdf',
  JPG = 'jpg',
  PNG = 'png',
  CSV = 'csv',
  DOC = 'doc',
  DOCX = 'docx',
  XLS = 'xls',
  XLSX = 'xlsx',
  AGS = 'ags',
  AQT = 'aqt',
}

export const WELLS_DEFAULT_EXTENSION_TYPES = Object.values(ExtensionTypes)

export enum MaxFileSize {
  MAX_SIZE = 10,
}

export enum RequiredText {
  ASTERISK = '*',
}

export enum SearchTypeKey {
  NATIONAL = 'search-wells-national',
  REGIONAL = 'search-wells-regional',
}

export const REVIEW_WELL_REQUIRED_STEPS = [
  'details',
  'construction',
  'lithology',
  'wellheadSecurity',
  'yieldDrawdownTest',
]

export const SCROLL_TARGET = '.l-record-container__content'

export const DEBOUNCE_DELAY = 300

export const CSV_EXPORT_FILE_NAME_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: true,
  timeZoneName: 'short',
}
